import type { Resolvers } from '../../../../generated';
import { syncSessionsMap } from '../sync-session';

export const resolvers: Resolvers = {
  Mutation: {
    setSyncSession: (_, vars) => {
      const syncSession = syncSessionsMap.get(vars.syncSessionId);
      const newSyncSession = {
        ...syncSession,
        ...vars.syncSession,
      };
      syncSessionsMap.set(vars.syncSessionId, newSyncSession);
      return newSyncSession;
    },
  },
};
